import { render, staticRenderFns } from "./new_info.vue?vue&type=template&id=645cd7e7&scoped=true&"
import script from "./new_info.vue?vue&type=script&lang=js&"
export * from "./new_info.vue?vue&type=script&lang=js&"
import style0 from "./new_info.vue?vue&type=style&index=0&id=645cd7e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645cd7e7",
  null
  
)

export default component.exports